import * as React from "react";
import { useState, useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import useFeature from "hooks/useFeature";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Input, Button } from "components/bootstrap";
import { Icon } from "components/common";
import Routes from "routing/Routes";
import { useAddEvidence, useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import useHistory from "routing/useHistory";
import { isPermitted } from "util/PermissionsMixin";
import { Row, FormGroup, EvidenceList, EvidenceRow, IconButton, StyledLink } from "../styled.components";
function Dashboards({ investigation }) {
  const { permissions } = useCurrentUser();
  const [newDashboardId, setNewDashboardId] = useState("");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteDashboardId, setDeleteDashboardId] = useState(null);
  const history = useHistory();
  const isRightSidebarEnabled = useFeature("investigation_right_sidebar");
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  const showAddForm = canManageEvidence && !isRightSidebarEnabled;
  const { addEvidence } = useAddEvidence();
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const isFormValid = useMemo(() => newDashboardId && newDashboardId.replace(/\s/g, "").length > 0, [newDashboardId]);
  const onAddDashboard = async (e) => {
    e.preventDefault();
    if (isFormValid) {
      await addEvidence({ invId: investigation.id, payload: { dashboards: [newDashboardId] } });
    }
    setNewDashboardId("");
  };
  const removeDashboard = async () => {
    await removeEvidence({ invId: investigation.id, payload: { dashboards: [deleteDashboardId] } });
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  const onDelete = (dashboardId) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteDashboardId(dashboardId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showAddForm && /* @__PURE__ */ React.createElement("form", { onSubmit: onAddDashboard }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "add-dashboard-id",
      type: "text",
      label: "Add Dashboard",
      "data-testid": "add-dashboard-id",
      autoComplete: "off",
      placeholder: "Enter dashboard ID",
      value: newDashboardId,
      onChange: (e) => setNewDashboardId(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", onClick: onAddDashboard, disabled: !isFormValid }, "Add"))), /* @__PURE__ */ React.createElement(EvidenceList, null, investigation.dashboards.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "gray" } }, "There are no dashboards to list") : investigation.dashboards.map((dashboard) => /* @__PURE__ */ React.createElement(EvidenceRow, { key: dashboard.id, $fullWidth: true, $gap: "0" }, canManageEvidence && /* @__PURE__ */ React.createElement(IconButton, { $danger: true, "data-testid": `delete-${dashboard.id}`, onClick: onDelete(dashboard.id) }, /* @__PURE__ */ React.createElement(Icon, { name: "close" })), /* @__PURE__ */ React.createElement(StyledLink, { onClick: () => history.push(Routes.VIEWS.VIEWID(dashboard.id)) }, dashboard.title)))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Dashboard",
      onConfirm: removeDashboard,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Dashboard?"
  ));
}
export default Dashboards;
